module.exports = __webpack_public_path__ + "images/2-3_3_News_circulars.jpg?aa174de";


//////////////////
// WEBPACK FOOTER
// ./assets/images/news/2-3_3_News_circulars.jpg
// module id = 178
// module chunks = 0